import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// On 401, surface a clean message via interceptors.
api.interceptors.response.use(
    (r) => r,
    (error) => {
        // Allow components to inspect the original error.
        return Promise.reject(error);
    },
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function apiErrorMessage(err, fallback = "Something went wrong.") {
    if (!err) return fallback;
    if (err.response?.data?.detail !== undefined) {
        return formatApiErrorDetail(err.response.data.detail);
    }
    return err.message || fallback;
}
